import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import Loading from '../Loading';
import ImageLoad from '../ImageLoad';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const DoctorsVideo = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("");
    const [allData, setAllData] = useState([]);
    const [search, setSearch] = useState("");
    const [departmentList, setDepartmentList] = useState([]);

    const HomeRef = useRef(false);
    const navigate = useNavigate();
    const Location = useLocation();
    const IsType = Location.pathname.startsWith("/video-consultation-doctors")

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const filteredData = allData
        .filter(item => !filter || item.name === filter)
        .map(item => ({
            ...item,
            doctors: item.doctors.filter(doc =>
                doc.title?.toLowerCase().includes(search.toLowerCase())
            )
        }))
        .filter(item => item.doctors.length > 0);


    useEffect(() => {

        navigator.geolocation.getCurrentPosition(
            position => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                fetchHomeData(lat, lng);
            }
        )
    }, []);

    const fetchHomeData = (lat, long) => {
        if (HomeRef.current) return;
        HomeRef.current = true;
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
            .then((res) => {
                console.log(res);
                const { ResponseCode, department_list } = res.data;
                if (ResponseCode === 200) {
                    setDepartmentList(department_list);
                    handleGetDepartmentDoc(department_list, lat, long);
                }
            })
            .catch((error) => {
                console.error("Home Api", error);
            });
    }

    const handleGetDepartmentDoc = async (department_list, lat, lon) => {
        try {
            const Url = IsType ? "/customer/dep_type_video_doctor" : "/customer/dep_type_client_doctor";
            const Type = IsType ? "video_consult" : "clinic_visit";

            const AllData = await Promise.all(department_list.map(async (dep) => {
                const res = await axios.post(
                    `${ApiBaseUrl + Url}`,
                    {
                        department_id: dep.id,
                        lat,
                        lon,
                        page: 1
                    }
                );
                return { name: dep.name, id: dep.id, doctors: res.data[Type] || [] }
            }));
            console.log(AllData);
            setAllData(AllData);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    }

    const NavigateHandle = (title, Id, departmentid) => {
        navigate(`/doctor-profile/${departmentid}/${Id}`);
        const pagename = IsType ? "Find Your Doctor" : "Book Clinic Visit";
        sessionStorage.setItem("Docprofile", JSON.stringify({ title: title, path: Location.pathname, pagename }));
    };

    if (loading) {
        return <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
    }

    return (
        <div className='w-full width-container content-wrapper details'>

            <div>
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                    {IsType ? "Find Your Doctor" : "Book Clinic Visit"}
                </h1>
                <span className="text-sm sm:text-base text-gray-600 line-clamp-2">
                    {IsType ? "Connect with expert doctors from anywhere, anytime • Available 24/7" : "Nearby doctors based on your location"}
                </span>
            </div>

            <div className="border p-[20px] mt-4 shadow rounded-[10px]">
                <div className="flex items-center gap-5">
                    <div className="w-full flex items-center gap-3 border px-[10px] rounded-[5px] focus-within:ring-2 focus-within:ring-[--button-color]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 w-5 h-5" aria-hidden="true">
                            <path d="m21 21-4.34-4.34"></path>
                            <circle cx="11" cy="11" r="8"></circle>
                        </svg>
                        <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className='w-full py-[8px] outline-none text-[18px]' placeholder='Search doctor' />
                    </div>
                    <div className="w-[200px]">
                        <select onChange={(e) => setFilter(e.target.value)} className='w-full border outline-none rounded-[5px] py-[9px] px-[10px] focus-within:ring-2 focus-within:ring-[--button-color]'>
                            <option value="">All Departments</option>
                            {departmentList.map((item, index) => (
                                <option key={index} value={item.name}>{item.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="mt-5">
                {filteredData.length >= 1
                    ? filteredData.map((item, index) => {
                        return <div key={index}>
                            <div className="mb-4 sm:mb-6">

                                <div className="flex items-center gap-2 sm:gap-3 mb-2">
                                    <div className="h-1 w-8 sm:w-12 bg-[--button-color] rounded-full"></div>
                                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{item.name}</h2>
                                    <div className="flex-1 h-1 bg-gray-200 rounded-full"></div>
                                    <span className="text-xs sm:text-sm font-semibold text-[--button-color] bg-[#4038FF]/10 px-2 sm:px-3 py-1 rounded-full whitespace-nowrap">{item.doctors.length} Doctors</span>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
                                    {item?.doctors?.map((doc, index2) => {
                                        return <div key={index2} onClick={() => NavigateHandle(doc.title, doc.id, item.id)} className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-xl transition-all duration-300 group h-full overflow-hidden">
                                            <div className="p-3 sm:p-4">
                                                <div className="flex items-start gap-2 sm:gap-3 mb-2 sm:mb-3 min-h-[90px] sm:min-h-[100px]">
                                                    <div className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-gray-100 to-gray-200 cursor-pointer hover:ring-2 hover:ring-[--button-color] transition-all">
                                                        <ImageLoad src={ImgBaseUrl + doc.logo} CustomeStyle={"object-cover"} alt={"Doctor img"} />
                                                    </div>
                                                    <div className="flex-1 min-w-0 overflow-hidden">
                                                        <div className="mb-0.5 sm:mb-1 min-h-[14px] sm:min-h-[16px]">
                                                            <span className="inline-block text-[9px] sm:text-[10px] md:text-xs font-medium text-[#4038FF] bg-[#4038FF]/10 px-1.5 sm:px-2 py-0.5 rounded">{doc.title}</span>
                                                        </div>
                                                        <h3 className="text-sm sm:text-base md:text-lg font-bold text-gray-900 mb-0.5 line-clamp-1 group-hover:text-gray-700 transition-colors min-h-[18px] sm:min-h-[22px] cursor-pointer">{doc.zone_name}</h3>
                                                        <div className="mb-2 sm:mb-2.5 min-h-[12px] sm:min-h-[28px]">
                                                            <p className="text-[9px] sm:text-[10px] md:text-xs text-gray-500 line-clamp-1 sm:line-clamp-2">{doc.subtitle}</p>
                                                        </div>
                                                        <div className="flex items-center gap-2 sm:gap-3 text-[10px] sm:text-xs mb-2 sm:mb-2.5">
                                                            {doc.avg_star !== 0
                                                                ? <div className="flex items-center gap-0.5 sm:gap-1 bg-green-50 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3 fill-green-500 text-green-500" aria-hidden="true">
                                                                        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                                    </svg>
                                                                    <span className="font-semibold text-green-700">{doc.avg_star}</span>
                                                                    <span className="text-gray-500 hidden sm:inline">({doc.tot_review})</span>
                                                                </div>
                                                                : <div className="flex items-center gap-0.5 sm:gap-1 text-gray-500">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                                                    </svg>
                                                                    <span>{t("No review")}</span>
                                                                </div>}

                                                            <div className="flex items-center gap-0.5 sm:gap-1 text-gray-600">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-award w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                                                    <circle cx="12" cy="8" r="6"></circle>
                                                                </svg>
                                                                <span>{doc.year_of_experience} {t("years")}</span>
                                                            </div>
                                                        </div>
                                                        <div className="flex gap-1.5 sm:gap-2 mb-2 sm:mb-2.5 flex-wrap">
                                                            {IsType
                                                                ? <div className="flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-[10px] sm:text-xs font-medium">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-video w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                        <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path>
                                                                        <rect x="2" y="6" width="14" height="12" rx="2"></rect>
                                                                    </svg>
                                                                    <span className="hidden sm:inline">{t("Video")}</span>
                                                                    {currency + doc.min_vid_price} - {currency + doc.max_vid_price}
                                                                </div>
                                                                : <div className="flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-2 py-0.5 bg-green-50 text-green-700 rounded-full text-[10px] sm:text-xs font-medium">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hospital w-2.5 h-2.5 sm:w-3 sm:h-3" aria-hidden="true">
                                                                        <path d="M12 7v4"></path>
                                                                        <path d="M14 21v-3a2 2 0 0 0-4 0v3"></path>
                                                                        <path d="M14 9h-4"></path>
                                                                        <path d="M18 11h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2"></path>
                                                                        <path d="M18 21V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16"></path>
                                                                    </svg>
                                                                    <span className="hidden sm:inline">{t("Clinic")}</span> {currency + doc.min_inp_price} - {currency + doc.max_inp_price}
                                                                </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <button className='book-btn'>{t("Book Appointment")}</button>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    })
                    : <div className="text-center py-12" >
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{t("No doctors found")}</h3>
                        <p className="text-gray-600">{t("Try adjusting your search")}</p>
                    </div>
                }
            </div>

        </div>
    )
}

export default DoctorsVideo